.bookingwidget {
  position: relative;
  z-index: 40;
  @media (--lg) {
    &.fullscreen {
      height:100%;
    }
  }
}
